import apiHandler from "../core/apiHandler";

/**
 * 🔢 API – Administración de Correlativos
 *
 * Endpoints:
 * - GET    /api/settings/correlatives
 * - POST   /api/settings/correlatives/{id}/reset
 * - POST   /api/settings/correlatives/reset-all
 */
const correlativesAdminApi = apiHandler("settings/correlatives");

export default correlativesAdminApi;
